/**
 * Start an action playing with the given opts. The defaults (weight 1,
 * timeScale 1) match the THREE.AnimationAction built-in so single-action
 * drivers can omit opts entirely.
 */
export function startAction(action, opts = {}) {
    const { weight = 1, timeScale = 1 } = opts;
    action.enabled = true;
    action.paused = false;
    action.setEffectiveWeight(weight);
    action.setEffectiveTimeScale(timeScale);
    action.play();
}
/**
 * Seek a paused action to `time`: start it (re-applying weight/timeScale on
 * the same call as play(), so the weight invariant holds whether or not the
 * action was already running), then hold it paused at the target time.
 */
export function seekAction(action, time, opts = {}) {
    startAction(action, opts);
    action.paused = true;
    action.time = time;
}
//# sourceMappingURL=actionHelpers.js.map